<template>
  <div id="drawer">
    <v-navigation-drawer
        :value="value"
        v-on:input="$emit('input', $event)"
        fixed
        temporary
        right
    >
      <v-list
          nav
          dense
      >
        <v-list-item-group
            v-model="group"
            class="mr-3"
        >
          <v-list-item class="my-2 d-flex justify-content-center">
            <v-list-item-title class="col-auto text-center">
              <router-link :to="{ path: '/Home'}">
                <div class="col-auto py-0" style="background-color: white">
                  <img :src="getImgUrl(logo)" height="45" contain/>
                </div>
              </router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="my-2 ">
            <v-list-item-title class="black--text drawer-border pb-3">
              <router-link :to="{ path: '/Home'}"><i class="fas fa-home primary-color "></i><span
                  class="pr-2">خانه</span></router-link>
            </v-list-item-title>
          </v-list-item>
          <v-divider/>
          <v-list-item class="my-2 ">
            <v-list-item-title class="black--text drawer-border pb-3">
              <router-link :to="{ path: '/aboutUs'}"><i class="fas fa-info-square"></i><span
                  class="pr-2">درباره ما</span>
              </router-link>
            </v-list-item-title>
          </v-list-item>
          <v-divider/>
          <v-list-item class="my-2">
            <v-list-item-title class="black--text drawer-border pb-3">
              <router-link :to="{ path: '/mission'}"><i class="fas fa-pencil-paintbrush primary-color"></i> <span
                  class="pr-2">ماموریت</span>
              </router-link>
            </v-list-item-title>
          </v-list-item>
          <v-divider/>
          <v-list-item class="my-2">
            <v-list-item-title class="black--text ">
              <router-link :to="{ path: '/termsAndConditions'}"><i class="fas fa-phone-square"></i><span
                  class="pr-2">اهداف</span>
              </router-link>
            </v-list-item-title>
          </v-list-item>
          <v-divider/>
          <v-list-item class="my-2 ">
            <v-list-item-title class="black--text drawer-border pb-3">
              <router-link :to="{ path: '/vision'}"><i class="fas fa-braille"></i><span class="pr-2">چشم انداز</span>
              </router-link>
            </v-list-item-title>
          </v-list-item>
          <v-divider/>
          <v-list-item class="my-2">
            <v-list-item-title class="black--text drawer-border pb-3">
              <router-link :to="{ path: '/catalog'}"><i class="fas fa-file-alt"></i> <span class="pr-2">کاتالوگ</span>
              </router-link>
            </v-list-item-title>
          </v-list-item>
          <v-divider/>
          <v-list-item class="my-2">
            <v-list-item-title class="black--text drawer-border pb-3">
              <router-link :to="{ path: '/photoGallery'}"><i class="fas fa-file-image"></i><span
                  class="pr-2">گالری محصولات</span>
              </router-link>
            </v-list-item-title>
          </v-list-item>
          <v-divider/>
          <v-list-item class="my-2">
            <v-list-item-title class="black--text ">
              <router-link :to="{ path: '/contactUs'}"><i class="fas fa-phone-square"></i><span
                  class="pr-2">ارتباط با ما</span>
              </router-link>
            </v-list-item-title>
          </v-list-item>
          <!--          <v-list-item class="my-2 ">
                      <v-list-item-title class="black&#45;&#45;text drawer-border pb-3">
                        <router-link :to="{ path: '/allProducts'}"><i class="fas fa-abacus"></i><span class="pr-2">محصولات</span>
                        </router-link>
                      </v-list-item-title>
                    </v-list-item>
                    <v-divider/>
                    <v-list-item class="my-2 ">
                      <v-list-item-title class="black&#45;&#45;text drawer-border pb-3">
                        <router-link :to="{ path: '/services'}"><i class="fab fa-servicestack"></i><span class="pr-2">خدمات</span>
                        </router-link>
                      </v-list-item-title>
                    </v-list-item>
                    <v-divider/>
                    <v-list-item class="my-2 ">
                      <v-list-item-title class="black&#45;&#45;text drawer-border pb-3">
                        <router-link :to="{ path: '/conference'}"><i class="fas fa-ballot-check"></i> <span
                            class="pr-2">مشاوره</span>
                        </router-link>
                      </v-list-item-title>
                    </v-list-item>
                    <v-divider/>
                    <v-list-item class="my-2">
                      <v-list-item-title class="black&#45;&#45;text ">
                        <router-link :to="{ path: '/termsAndConditions'}"><i class="fas fa-balance-scale"></i><span class="pr-2">قوانین و مقررات</span>
                        </router-link>
                      </v-list-item-title>
                    </v-list-item>
                    <v-divider/>-->
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  name: "navigationDrawer",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    drawer: true,
    group: null,
    logo: 'mainLogo.png',

  }),
  methods: {
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
  }
}
</script>

<style scoped>

</style>